import { createSelector } from 'reselect';

export const Types = {
  GET_REQUEST: 'users/GET_REQUEST',
  GET_SUCCESS: 'users/GET_SUCCESS',
  GET_FAILURE: 'users/GET_FAILURE',

  GET_LIST_REQUEST: 'users/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'users/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'users/GET_LIST_FAILURE',

  UPDATE_REQUEST: 'users/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'users/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'users/UPDATE_FAILURE',

  GET_GROUPS_REQUEST: 'users/GET_GROUPS_REQUEST',
  GET_GROUPS_SUCCESS: 'users/GET_GROUPS_SUCCESS',
  GET_GROUPS_FAILURE: 'users/GET_GROUPS_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  update: {
    loading: false,
  },

  groups: {
    data: [],
    loading: false,
  },
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.group.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.users.data,
        page: action.payload.page,
        totals: 2000,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_GROUPS_REQUEST:
      return {
        ...state,
        groups: {
          ...state.groups,
          loading: false,
        },
      };
    case Types.GET_GROUPS_SUCCESS:
      return {
        ...state,
        groups: {
          ...state.groups,
          loading: false,
          data: action.payload.groups.data,
        },
      };
    case Types.GET_GROUPS_FAILURE:
      return {
        ...state,
        groups: {
          ...state.groups,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getUserRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getUserSuccess: group => ({
    type: Types.GET_SUCCESS,
    payload: { group },
  }),

  getUserFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getUsersRequest: (page = 1, filters = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filters },
  }),

  getUsersSuccess: (users, page) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { users, page },
  }),

  getUsersFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  updateUserRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateUserSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateUserFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  getUsersGroupsRequest: (query = '') => ({
    type: Types.GET_GROUPS_REQUEST,
    payload: { query },
  }),

  getUsersGroupsSuccess: groups => ({
    type: Types.GET_GROUPS_SUCCESS,
    payload: { groups },
  }),

  getUsersGroupsFailure: () => ({
    type: Types.GET_GROUPS_FAILURE,
  }),
};

export const Selectors = {
  groups: createSelector(
    state => state,
    groups => groups.map(groups => ({ value: groups.id, label: groups.attributes.title })),
  ),
};
